/**
 * Created by anthony on 7/3/14.
 */

/**
 * Created by anthony on 7/7/14.
 */
var applicantModel = angular.module('applicantModel', []);
applicantModel.factory('ApplicantModelFactory', function(ApplicationService, AbstractModelService, authServiceFactory, AppModelFactory){
    var ApplicantModel = function(){
        this.endpoint = "/applicant";
        this.dataProperty = "applicants";
        this.primaryKey = "recordID";
    }

    ApplicantModel.prototype = new AppModelFactory();
    ApplicantModel.prototype.parent = AppModelFactory.prototype;
    ApplicantModel.prototype.resolveData = function()
    {
        var parent = this;
        this.parent.data = ApplicationService.getAwardData()['applicants'];
    }
    ApplicantModel.prototype.new = function()
    { 
        this.resolveData();
        return this.data.push(
            {
                App_SSNI20: '',App_SSNI20Select: '', App_Last: '',App_Middle: '',App_First: '',App_Suffix: '',  App_DOB: '',
                App_Gender: 0,App_Division: '',  App_Div_Code: '',App_Tuition: '',RecomAward: 0,ConsiderAward: 0, 
                ConsiderAward_F1: 0, ConsiderAward_F2: 0,  ActAward: 0, ActAward_F1: 0, ActAward_F2: 0, Notes: '',Status: '', 
                App_Trust_Val: 0,App_Trust_Desc: '', App_SS_Inc: 0,App_Complete: 0, applicantID: '', App_529: 0,App_Holds: 0, Res_F1: 1,Res_F2: 0,
                del: 0,xApp_First: '', xApp_Middle: '',xApp_Last: '',xApp_Suffix: '',xApp_DOB: '',xApp_Gender: '', 
                xApp_Div_Code: '',xApp_529: '', xApp_SS_Inc: '',xApp_Trust_Val: '', added: 0
            }
        ) - 1;
    }
    ApplicantModel.prototype.get = function(id)
    {
        return AbstractModelService.get("/api/app/" + id + "/applicant");
    }
    ApplicantModel.prototype.post = function(id, data, instance)
    {
        return AbstractModelService.post("/api/app/" + ApplicationService.getAwardData().applicants[0].applicationID + "/applicant", data, instance);
    }
    ApplicantModel.prototype.put = function(id, data, instance)
    {
        return AbstractModelService.put("/api/app/" + ApplicationService.getAwardData().applicants[0].applicationID + "/applicant/" + id, data, instance);
    }
    ApplicantModel.prototype.purge = function(id, data, instance)
    {
        data['del']==1;
        return AbstractModelService.put("/api/app/" + ApplicationService.getAwardData().applicants[0].applicationID + "/applicant/" + id, data, instance);
    }
    return ApplicantModel;
});

applicantModel.service('ApplicantModelService', function(ApplicantModelFactory){
    var applicantModel = new ApplicantModelFactory();
    return applicantModel;
});
